<template>
  <div :style="buttonCardStyle">
    <v-card-text v-bind:style="buttonTitleStyle">
      {{ titleContent }}
    </v-card-text>
    <v-btn :style="btnCss">
      <span v-if="labelName == 'speechBubble'" class="bubble_span__talk">物件の資料を見たい方はコチラ！</span>
      <span v-else-if="labelName == 'quadrangle'" class="bubble_span">物件の資料を見たい方はコチラ！</span>
      <font-awesome-icon v-if="beforeIcon" :icon="beforeIcon" />
      <span class="ma-auto"> {{ btnContent }} </span>
      <font-awesome-icon v-if="afterIcon" :icon="afterIcon" />
    </v-btn>
  </div>
</template>
<script>
export default {
  name: 'ButtonTemplateItem',
  data () {
    return {
      buttonCardStyle: {
        'cursor': 'pointer',
        'align-items': 'center',
        'background-color': '#EEEEEE',
        'margin-top': '15px',
        'display': 'flex',
        'flex-direction': 'column',
        'justify-content': 'space-evenly',
        'height': '110px',
        'padding': 0,
        'margin': '15px 1px 1px 0px',
        'width': '300px'
      },
      buttonTitleStyle: {
        'height': '20px',
        'width': '250px',
        'font-size': '12px',
        'border-radius': '5px',
        'padding': 0,
        'text-align': 'center',
        'background-color': 'white',
        'margin-bottom': '8px'
      }
    }
  },
  props: {
    btnCss: {
      type: Object,
      required: true
    },
    titleContent: {
      type: String,
      required: true
    },
    btnContent: {
      type: String,
      required: true
    },
    labelName: {
      type: String
    },
    beforeIcon: {
      type: String
    },
    afterIcon: {
      type: String
    }
  }
}
</script>

<style scoped lang="sass">
.bubble_span__talk
  font-size: 8px
  position: absolute
  top: -1.25rem
  display: block
  width: 160px
  padding: 0.2rem 0
  letter-spacing: 0.001rem
  color: #007bff
  border: 2px solid #007bff
  border-radius: 100vh
  background: #fff
  -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%)
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%)
  padding:0
  &::before
      bottom: -4px
      border-width: 5px 5px 0
      border-style: solid
      border-color: #fff transparent transparent
      position: absolute
      left: calc(50% - 10px)
      content: ''

.bubble_span
    position: absolute
    border: 2px solid #007bff
    color: rgb(10, 83, 190)
    top: -1.25rem
    background: #fff
    letter-spacing: 0.001rem

</style>
